import React, { useState, useEffect } from "react";
import SubHead from "./SubHead";
import imgVision from "../../assets/img_vision_cont.jpg";
import ScrollOut from "scroll-out";
import { Font } from "@react-pdf/renderer";

const Vision = () => {
    useEffect(() => {
        ScrollOut({
            threshold: 0.3,
            once: true
        });
    }, []);

    return (
        <>
            <SubHead title="비전" eng="VISION"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div className="vision-info-wrap top">
                        <div className="title" data-scroll>
                            <p>VISION</p>
                        </div>
                        <div className="cont">
                            <p class="tit-guide-sbj" data-scroll>
                                {/* kt MOS북부는고객의 삶의 <b>변화</b>와 <br />
                                다른 산업의 <b>혁신</b>을 리딩하여 <b>대한민국 발전</b>에 기여한다. */}
                                고객의 보다 나은 미래를 만드는 AI 혁신 파트너
                                <br />
                                <p style={{ fontSize: 32 }}>kt MOS북부의 유무선 통신과 AX 역량으로 고객이 필요로 하는 가치를 제공하여 고객의 더 발전된 미래를 만드는데 기여하겠습니다.</p>
                            </p>

                            <div className="vision-imgs" data-scroll>
                                <img src={imgVision} alt="Network Service" />
                            </div>
                        </div>
                    </div>
                    <div className="vision-info-wrap bottom gray-back-bg">
                        <div className="title" data-scroll>
                            <p>VALUE</p>
                        </div>
                        <div className="cont">
                            <ul className="vision-value-ul" data-scroll>
                                <li>
                                    <div className="icon_box n01"></div>
                                    <p className="sbj">고객</p>
                                    <p className="txt">고객의 니즈 충족과 문제 해결을 위해 치열하게 고민하고 새로운 고객경험을 제시합니다.</p>
                                </li>
                                <li>
                                    <div className="icon_box n02"></div>
                                    <p className="sbj">역량</p>
                                    <p className="txt">고객의 문제를 해결하고 고객이 원하는 혁신을 가장 잘 할 수 있도록 전문성을 높입니다.</p>
                                </li>
                                <li>
                                    <div className="icon_box n03"></div>
                                    <p className="sbj">실질</p>
                                    <p className="txt">우리의 본업인 통신과 ICT를 단단히 하고 화려한 겉모습보다 실질적인 성과를 추구합니다.</p>
                                </li>
                                <li>
                                    <div className="icon_box n04"></div>
                                    <p className="sbj">화합</p>
                                    <p className="txt">다름을 인정하되 서로 존중하고 합심해 함께 목표를 이뤄갑니다.</p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Vision;
